exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainContainer {\n    margin-top: 10px;\n}\n\n.small-button {\n  font-size: 0.7em;\n}\n\n.sticky{\n    position: -webkit-sticky;\n    position: sticky;\n    top: 58px;\n    background-color: white;\n    width: 100%;\n    padding: 5px 0;\n    z-index: 100;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/vieworder/vieworder.component.css
// module id = ../../../../../src/app/vieworder/vieworder.component.css
// module chunks = main